module.exports = __webpack_public_path__ + "img/icon-left-arrow-iphone.3801b447.png";